import { render, staticRenderFns } from "./MStoreDocumentInformationTab.vue?vue&type=template&id=718fc22e&"
import script from "./MStoreDocumentInformationTab.vue?vue&type=script&lang=ts&"
export * from "./MStoreDocumentInformationTab.vue?vue&type=script&lang=ts&"
import style0 from "./MStoreDocumentInformationTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports